import React from 'react';
import { useSelector } from 'react-redux';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { getFormattedDate } from '../../../../global/helpers/date-helpers';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { PersonLov } from '../../../../global/models/lov-proc-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { GroupAdminAddFormValues } from '../../../arc/features/groups/admin/group-admin-add-form-model';
import { OfficerAddFormValues } from '../../../arc/features/institution-officers/officer-add-form-model';
import { DependentFormValues } from '../../features/dependents/dependent-form-models';
import { MaritalStatusFormValues } from '../../features/marital-status/marital-form-models';
import { PersonalInfoFields } from '../../models/form-models';

interface PersonFieldsProps {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | PersonalInfoFields;
    labelSetting: LabelSettingProps;
    dobMasked?: boolean;
}

export function PersonFieldsContentDisplay(props: PersonFieldsProps) {
    const { values, labelSetting, dobMasked } = props;

    const personLov = useSelector<TcsmStates, PersonLov>(state => state.lovProcState?.personLov);
    const salutations = personLov?.salutation_designation;
    const genders = personLov?.gender;

    const mappedSalutation = salutations[values.designation_salutation] || values.designation_salutation;
    const mappedGender = genders[values.gender] || values.gender;

    let genderIdValues = values?.gender_identity ?? [];  

    if (values?.gender_identity_other){
        const newArray = genderIdValues.map((item: string) => item === 'Self-describe' ? `${item}: ${values?.gender_identity_other}` : item);
        genderIdValues = newArray;
    }
    const genderIdValue = genderIdValues?.join(', ');

    return (
        <>
            {values.designation_salutation && <LabelAndValue label={labelSetting.salutationLabel} value={mappedSalutation} />}
            <LabelAndValue label={labelSetting.firstNameLabel} value={values.first_name} />
            {values.middle_name && <LabelAndValue label={labelSetting.middleNameLabel} value={values.middle_name} />}
            <LabelAndValue label={labelSetting.lastNameLabel} value={values.last_name} />
            {values.suffix && <LabelAndValue label={labelSetting.suffixLabel} value={values.suffix} />}
            {values.known_as && <LabelAndValue label={labelSetting.preferredLabel} value={values.known_as} />}
            {values.gender && <LabelAndValue label={labelSetting.genderLabel} value={mappedGender} />}
            {values.gender_identity?.length > 0 && <LabelAndValue label={labelSetting.genderIdentityLabel} value={genderIdValue} />}
            {values.date_of_birth && <LabelAndValue label={labelSetting.dobLabel} value={dobMasked ? values.date_of_birth : getFormattedDate(values.date_of_birth)} />}
            {values.tax_id && <LabelAndValue label={labelSetting.ssnTinLabel} value={values.tax_id} />}
        </>
    );
}

PersonFieldsContentDisplay.defaultProps = {
    dobMasked: false,
};


interface Props {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | PersonalInfoFields;
    labelSetting: LabelSettingProps;
    sectionText?: string;
    dobMasked?: boolean;
}
export function PersonFieldsDisplay(props: Props) {
    const { values, labelSetting, sectionText, dobMasked } = props;

    return (
        <DividerSection removeDivider sectionText={sectionText}>
            <PersonFieldsContentDisplay
                labelSetting={labelSetting}
                values={values}
                dobMasked={dobMasked}
            />
        </DividerSection>

    );
}

PersonFieldsDisplay.defaultProps = {
    dobMasked: false,
    sectionText: '',
};
